/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'

interface IHasEmpty {
  children: React.ReactNode
  length: number
  loading: boolean
  emptySlot: React.ReactNode
}

export default function HasEmpty({
  children,
  length,
  loading,
  emptySlot
}: IHasEmpty) {
  return <>
    {
      length ? <>
        {children}
      </> : !loading && emptySlot
    }
  </>
}
